import CustomerSupport from "examples/Icons/CustomerSupport";
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';

const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "unit",
  //   route: "/admin/dashboard",
  //   activePaths: ["/admin/dashboard"],
  //   icon: <SpaceDashboardIcon size="12px" />,
  //   noCollapse: true,
  //   children: []
  // },
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "users",
  //   route: "/admin/user",
  //   icon: <CustomerSupport size="12px" />,
  //   component: null,
  //   noCollapse: false,
  //   children: [

  //   ]
  // },

    {
    type: "collapse",
    name: "Properties",
    key: "properties",
    route: "/admin/properties",
    activePaths: ["/admin/properties", "/admin/managers", "/admin/concierge"],
    icon: <CustomerSupport size="12px" />,
    component: null,
    noCollapse: false,
    children: []
  },
  // {
  //   type: "collapse",
  //   name: "Access Control",
  //   key: "access-control",
  //   route: "/admin/access-control",
  //   icon: <CustomerSupport size="12px" />,
  //   component: null,
  //   noCollapse: false,
  //   children: []
  // }

  // {
  //   type: "collapse",
  //   name: "Property",
  //   key: "property",
  //   route: "/admin/properties",
  //   icon: <Shop size="12px" />,
  //   component: <Property />,
  //   noCollapse: true,
  //   children: [


  //   ]
  // },


];

export default routes;
